import { useReturnBearLocations } from "@redotech/redo-customer-portal-shared/hooks/useShipmentLocations/use-shipment-locations";
import MarkerPin01Svg from "@redotech/redo-icons/marker-pin-01.svg";
import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import { RedoModal } from "@redotech/redo-web/arbiter-components/modal/redo-modal";
import { Flex } from "@redotech/redo-web/flex";
import { LoadingRedoAnimation } from "@redotech/redo-web/loading-redo-animation";
import { Text } from "@redotech/redo-web/text";
import { memo, useState } from "react";
import { InteractiveMap } from "../in-store-locations";

const ReturnBearLocationsModal = memo(function ReturnBearLocationsModal({
  draftReturnId,
  returnId,
}: {
  draftReturnId?: string;
  returnId?: string;
}) {
  const { locationsLoad } = useReturnBearLocations(draftReturnId, returnId);

  if (locationsLoad.pending) {
    return <LoadingRedoAnimation />;
  }

  if (locationsLoad.error) {
    return <Text textColor="error">Error loading Return Bear locations</Text>;
  }

  if (!locationsLoad.value) {
    return null;
  }

  return <InteractiveMap locations={locationsLoad.value} />;
});

export const ReturnBearLocationsButton = memo(
  function ReturnBearLocationsButton({
    draftReturnId,
    returnId,
    autoOpen = false,
  }: {
    draftReturnId?: string;
    returnId?: string;
    autoOpen?: boolean;
  }) {
    const [isOpen, setIsOpen] = useState(autoOpen);
    return (
      <Flex>
        <RedoButton
          hierarchy="secondary"
          IconLeading={() => <MarkerPin01Svg />}
          onClick={(e) => {
            e.preventDefault();
            setIsOpen(true);
          }}
          text="See available locations"
        />
        <RedoModal
          isOpen={isOpen}
          onModalCloseRequested={() => setIsOpen(false)}
          title="Find Return Bear drop-off locations"
        >
          <ReturnBearLocationsModal
            draftReturnId={draftReturnId}
            returnId={returnId}
          />
        </RedoModal>
      </Flex>
    );
  },
);
